import React from "react";
import AgentInfoService from "../services/Agent/AgentInfoService";
import "../scss/SocialMediaModal.css";
import ToastHelper from "../utils/ToastHelper";
import UserSessionService from "../services/UserSessionService";
import SocialMediaModalComponent from "./SocialMediaModalComponent";

export default class SendAgentLinkModalComponent extends React.Component {
    constructor(props) {
        super(props);
        let agentName = UserSessionService.getUser().user.firstName + ' ' + UserSessionService.getUser().user.lastName;
        this.state ={url: "",
            agentName: agentName}
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isOpen === false && this.props.isOpen) {
            let promise = AgentInfoService.retrieveAgentReferralLink()
            promise.then((val) => {
                if (val !== undefined && val.referral !== undefined) {
                    this.setState({url: val.referral})
                } else if (val["errors"]) {
                    ToastHelper.formatError(val)
                } else {
                    ToastHelper.formatError("Unable to retrieve agent referral url")
                }
            })
        }
    }


    render() {
        const shareMessage =  `${this.state.agentName} has sent you this link. Sign up with Sikhona Money Transfers to send money now: `
        return <SocialMediaModalComponent
            isOpen = {this.props.isOpen}
            title={"Send Registration Link"}
            messageTitle={"Sign up with Sikhona"}
            message = {shareMessage}
            url = {this.state.url}
            handler = {this.props.handler}
            canCopyUrl = {true}
            canBeSharedOnEmail = {true}
            canBeSharedOnWhatsapp = {true}
        ></SocialMediaModalComponent>
    }

}